export default function PageHero({ eyebrow, title, desc, image }) {
  return (
    <header className="page-hero">
      <img src={image} alt="" aria-hidden="true" />
      <div className="page-hero-overlay" />
      <div className="container page-hero-content">
        <p className="hero-eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {desc ? <p>{desc}</p> : null}
      </div>
    </header>
  );
}
